import React from 'react';
import { steps } from '../data/content';
export function Process() {
  return <section aria-labelledby="process-heading" className="border-b border-hairline bg-white py-20 sm:py-24" data-id="element-97" data-mp="1udd6xm41f8hi">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-98" data-mp="1yeyohkrioay1">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,360px)_minmax(0,1fr)] lg:gap-16" data-id="element-99" data-mp="1yddt5sxdonz4">
          <div data-id="element-100" data-mp="23bxim3b6khw8">
            <h2 id="process-heading" className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-101" data-mp="16oar8jsyrppn">
              How we work
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-ink-muted" data-id="element-102" data-mp="1fopg1t54zmxw">
              A short, predictable engagement process. You approve the scope
              before any work begins.
            </p>
          </div>

          <ol className="relative space-y-8" data-id="element-103" data-mp="n0l8f2308zsk">
            {steps.map(step => <li key={step.number} className="flex gap-5" data-id="element-104" data-mp="ryv3zdsn62ep">
                <span aria-hidden="true" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-accent text-sm font-semibold text-accent" data-id="element-105" data-mp="rxbnpn6zjrcx">
                  {step.number}
                </span>
                <div className="pt-1" data-id="element-106" data-mp="10rmfos4lnhce">
                  <h3 className="text-base font-semibold text-ink" data-id="element-107" data-mp="10qkuvvxs7ghh">
                    {step.number}. {step.title}
                  </h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-ink-muted" data-id="element-108" data-mp="quzwe7rx8ych">
                    {step.description}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}